import React from 'react';
import { useLocation } from 'react-router-dom';

const TrailContext = React.createContext(null);

export function TrailProvider({ children }) {
  const location = useLocation();


  const [pageCrumb, setPageCrumb] = React.useState(null);

  const trail = React.useMemo(() => {
    const incoming = location.state?.trail || [];
    if (!pageCrumb) return incoming;
    const last = incoming[incoming.length - 1];
    if (last && (last.label === pageCrumb.label || last.href === pageCrumb.href)) return incoming;
    return [...incoming, pageCrumb];
  }, [location.state, pageCrumb]);

  const value = React.useMemo(
    () => ({
      trail,
      setPageCrumb,
      linkState: { trail }, 
    }),
    [trail]
  );

  return <TrailContext.Provider value={value}>{children}</TrailContext.Provider>;
}

export function useCrumb(label, href) {
  const ctx = React.useContext(TrailContext);
  React.useEffect(() => {
    if (!ctx) return;
    ctx.setPageCrumb({ label, href });
    return () => ctx.setPageCrumb(null);
  }, [label, href, ctx?.setPageCrumb]);
  return ctx?.linkState; 
}

export function useNavWithTrail(navigate) {
  const ctx = React.useContext(TrailContext);
  return React.useCallback(
    (to, options = {}) =>
      navigate(to, {
        ...(options || {}),
        state: { ...(options?.state || {}), ...(ctx?.linkState || {}) },
      }),
    [navigate, ctx]
  );
}

export function useTrail() {
  return React.useContext(TrailContext)?.trail || [];
}
